import React, { useEffect, useState } from 'react';
import {
  makeStyles,
  Typography, Card, CardContent,
  CardMedia, Divider,
  Grid
} from '@material-ui/core';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import './index.scss';
import { deepOrange } from '@material-ui/core/colors';

/**Connections */
import CustomizedSelects from '../../components/PlaylistCard/Dropdowns'
import InstorexLogo from '../../assets/images/video1.jpg';

import PreviewModal from '../../components/PlaylistCard/Modals/previewModal'


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: 'transparent',
    flexGrow: 1,
    padding: 15,
  },
  root1: {
    alignContent: 'center',
    width: 175,
    height: 260,
    textAlign: 'left',
    margin: 6,

  },
  dialogAction: {
    marginTop: 1,
  },
  media: {
    height: 90,
    margin: 15,

  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    backgroundColor: '#252525',
    color: theme.palette.text.secondary,

  },
  textDesign: {
    textAlign: 'left',
    color: '#ff5722',
    fontSize: 30,
  },
  textDesign1: {
    textAlign: 'left',
    fontSize: 17,
    color: '#ffffff',
  },
  textDesign2: {
    textAlign: 'left',
    color: '#ffffff',
    fontWeight: 'bold',
    fontSize: 20,
  },
  buttonColor: {
    backgroundColor: '#ff5722',
    height: 40,
    width: 150,
    fontSize: 18,
    color: '#ffffff'
  },
  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '2rem 0',
  },
  cardheader: {
    backgroundColor: deepOrange[500],
  },
  truncate2Rows: {
    width: '155px',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
  },
}));

export default function DropArea(props) {
  const classes = useStyles();
  const [isPreviewModalShow, setIsPreviewModalShow] = useState({
    selectedVideoIndex: 0,
    isShow: false
  });

  return (
    <div id="contentContainer"
      className="drop-area">
      {
        props.items.map((itemPerRow, index) => (
          <Droppable droppableId={"BAG" + index} direction="horizontal"
            isCombineEnabled={false}>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                style={{ width: '100%' }}
              >
                {
                  itemPerRow.items !== undefined &&
                  <Grid container>
                    {
                      itemPerRow.items.map((item, indexSub) => (
                        <Draggable key={item.uniqueId} draggableId={'draggableId1-' + item.uniqueId} index={item.index}>
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <Card className={classes.root1} >
                                <Grid container>
                                  <Typography style={{ fontSize: '30px', backgroundColor: '#ef6c00', minWidth: '30px' }}
                                    onClick={() => {
                                      setIsPreviewModalShow({
                                        selectedVideoIndex: item.index,
                                        isShow: true
                                      })
                                    }}>
                                    <a style={{ marginLeft: '2px', marginRight: '2px' }}>
                                      {item.index + 1}
                                    </a>
                                  </Typography>
                                  <CustomizedSelects item={item} setSchedTimeCallback={props.setSchedTimeCallback}
                                    removeContentCallback={props.removeContentCallback}
                                    setDurationCallback={props.setDurationCallback} itemsLeftContent={props.itemsLeftContent} />
                                </Grid>
                                <CardMedia image={item.thumbnailUrl === undefined || item.thumbnailUrl === ''
                                  ? InstorexLogo : item.thumbnailUrl}
                                  title="Test" className={classes.media}
                                  onClick={() => {
                                    setIsPreviewModalShow({
                                      selectedVideoIndex: item.index,
                                      isShow: true
                                    })
                                  }} />
                                <CardContent style={{ textAlign: 'left', fontSize: 15, marginTop: '-10px' }}
                                  onClick={() => {
                                    setIsPreviewModalShow({
                                      selectedVideoIndex: item.index,
                                      isShow: true
                                    })
                                  }}>
                                  <Typography style={{ fontSize: 14 }} gutterBottom variant="body2" component="h2">
                                    <span style={{ fontWeight: 'bold' }}>Filename: </span>
                                    <span className={classes.truncate2Rows} style={{ fontSize: 12, wordWrap: 'break-word' }}>{item.fileName}</span>
                                    <Divider></Divider>
                                    <span style={{ fontWeight: 'bold' }}>Type: </span>{item.type}
                                  </Typography>
                                </CardContent>
                              </Card>
                            </div>
                          )}
                        </Draggable>
                      ))}
                    {provided.placeholder}
                  </Grid>
                }
              </div>
            )}
          </Droppable>
        ))
      }
      {
        isPreviewModalShow.isShow ? <PreviewModal contents={props.itemsLeftContent}
          selectedVideoIndex={isPreviewModalShow.selectedVideoIndex}
          modalShow={isPreviewModalShow.isShow}
          modalState={setIsPreviewModalShow}
        /> : ''
      }
    </div>
  );
}